import { Injectable } from "@angular/core";
import { HttpClient } from "@app/shared/services/http/http-client.service";
import { Observable } from "rxjs";

export interface KqlQueryExample {
  id: string;
  description: string;
  query: string;
  dateCreatedUtc: string;
  dateLastModifiedUtc: string;
}

export interface CreateKqlQueryExampleModel {
  description: string;
  query: string;
}

export interface UpdateKqlQueryExampleModel {
  id: string;
  description: string;
  query: string;
}

@Injectable()
export class KqlQueryService {
  constructor(private http: HttpClient) {}

  list(): Observable<KqlQueryExample[]> {
    return this.http.get<KqlQueryExample[]>("api/KqlQueryExample/list");
  }

  get(id: string): Observable<KqlQueryExample> {
    return this.http.get<KqlQueryExample>(`api/KqlQueryExample/get/${id}`);
  }

  create(model: CreateKqlQueryExampleModel): Observable<KqlQueryExample> {
    return this.http.post<KqlQueryExample>("api/KqlQueryExample/create", model);
  }

  update(model: UpdateKqlQueryExampleModel): Observable<KqlQueryExample> {
    return this.http.put<KqlQueryExample>("api/KqlQueryExample/update", model);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`api/KqlQueryExample/delete/${id}`);
  }
}

